'use client'

import dynamic from 'next/dynamic'

// This must be a client component to use ssr: false
const CookieBanner = dynamic(() => import('./CookieBanner'), {
  ssr: false,
  loading: () => null, // No loading state needed for cookie banner
})

export default function CookieBannerWrapper() {
  return <CookieBanner />
}
